import React from "react";

import { Roles } from "model/options";

import { SelectField, InputField } from "basics";

import { FilterContainer } from "components/ToolBar/styles";

export default function UserToolbar({ updateFiltering }) {
  const handleTextFilter = (field, value) => {
    updateFiltering(field, "contains", value.length >= 3 ? value : undefined);
  };

  const handleRoleFilter = (field, value) => {
    updateFiltering(field, "role-checked", value);
  };

  return (
    <FilterContainer>
      <SelectField
        options={Roles}
        id="roles"
        label="Filtrar por Rol"
        defaultOption="Todos los roles"
        onChange={handleRoleFilter}
      />
      <InputField
        label="Filtrar por nombre"
        type="text"
        id="title"
        placeholder="ingrese por lo menos 3 letras"
        onChange={handleTextFilter}
      />
    </FilterContainer>
  );
}
